import { useNavigate } from 'react-router-dom';
import { mockPublicJobs } from '@/mocks/public';

export default function PublicJobsList() {
  const navigate = useNavigate();

  const formatSalary = (from?: number, to?: number) => {
    if (!from && !to) return '';
    const f = from ? `${from.toLocaleString('ru-RU')} ₽` : '';
    const t = to ? `${to.toLocaleString('ru-RU')} ₽` : '';
    if (f && t) return `${f} — ${t}`;
    return f || t;
  };

  return (
    <div className="min-h-screen bg-background-50">
      {/* Hero */}
      <div className="relative bg-foreground-950 text-white overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20technology%20background%20with%20flowing%20geometric%20grid%20lines%20and%20soft%20warm%20light%20particles%2C%20charcoal%20black%20with%20subtle%20emerald%20green%20glow%20accents%2C%20modern%20corporate%20tech%20aesthetic%2C%20clean%20minimal%20composition%2C%20no%20text%2C%20suitable%20for%20SaaS%20careers%20page%20hero&width=1600&height=500&seq=public-jobs-hero-01&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/50"></div>
        <div className="relative z-10 max-w-[1200px] mx-auto px-6 py-16 md:py-20 text-center">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center">
              <span className="text-white font-heading font-bold text-sm">S</span>
            </div>
            <span className="text-sm text-white/60">Starec AI</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-heading font-bold mb-3">
            Вакансии
          </h1>
          <p className="text-sm text-white/50 max-w-lg mx-auto">
            Присоединяйтесь к команде Starec AI. Мы строим будущее HR-технологий с помощью искусственного интеллекта.
          </p>
        </div>
      </div>

      {/* Jobs list */}
      <div className="max-w-[800px] mx-auto px-6 py-12 md:py-16">
        <div className="space-y-4">
          {mockPublicJobs.map((job) => (
            <div
              key={job.slug}
              onClick={() => navigate(`/public/vacancy/${job.slug}`)}
              className="bg-white rounded-xl border border-background-200 p-5 md:p-6 hover:border-primary-300 hover:shadow-sm transition-all cursor-pointer group"
            >
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
                <div className="flex-1">
                  <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors">
                    {job.title}
                  </h3>
                  <div className="flex flex-wrap items-center gap-3 mt-2 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-map-pin-line"></i>
                      {job.location}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-briefcase-line"></i>
                      Полная занятость
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  {job.salary_from && (
                    <span className="text-sm font-heading font-semibold text-emerald-600">
                      {formatSalary(job.salary_from, job.salary_to)}
                    </span>
                  )}
                  <i className="ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="bg-foreground-950 text-white/40 py-8 px-6">
        <div className="max-w-[1200px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded bg-white/10 flex items-center justify-center">
              <span className="text-white font-heading font-bold text-xs">S</span>
            </div>
            <span className="text-sm text-white/60">Starec AI</span>
          </div>
          <p className="text-xs">
            Работает на HR.Starec — AI-платформа подбора персонала
          </p>
        </div>
      </div>
    </div>
  );
}